import React from 'react';
import { CardContent, CardHeader } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import { Card, CardHeaderTitle, PlainLink } from '../../../../ui-kit';
import { routePaths } from '../../../../routePaths';

interface WarehouseDetailsCardProps {
    warehouseName: string;
    id: string;
}

const WarehouseDetailsCardView = ({ warehouseName, id }: WarehouseDetailsCardProps) => {
    const location = useLocation();

    return (
        <PlainLink
            to={{
                    pathname: `${routePaths.warehouses}/${id}`,
                    state: { background: location },
                }}
        >
            <Card>
                <CardHeader
                    disableTypography
                    title={<CardHeaderTitle>{warehouseName}</CardHeaderTitle>}
                />
                <CardContent>
                </CardContent>
            </Card>
        </PlainLink>
    );
};

export default WarehouseDetailsCardView;
